$(window).on("load", function () {
	let selects = $(".js-select");

	if (selects) {
		selects.each(function () {
			const that = $(this);
			const defOption = $(
				'<option value="Country" data-provinces="[]" selected disabled></option>'
			);

			const ph = $(
				'<div class="placeholder-select">Country <span>*</span></div>'
			);

			$(this).find("option:first-child").remove();
			$(this).prepend(ph);
			$(this).find("select").prepend(defOption);

			$(this)
				.find("select")
				.change(function (e) {
					$(this).css("color", "rgb(var(--color-foreground), 1)");
					that.find(".placeholder-select").remove();
				});
		});
	}
});

$(document).on("click", ".login__toggle", function () {
	$(".login__reset").toggle();
	$(".login__form").toggle();
});

// ==================================================
// 会員登録 (生年月日/性別) : option 生成 + note まとめ (Flow 用)
// 登録フォームで (生年月日/性別/パスワード確認) を必須チェックし
// エラーは各項目の下に表示、OK のときだけ customer.note にまとめて保存する
// ==================================================
$(window).on("load", function () {

  // 会員登録フォームだけを対象にする (ログインフォームなどを誤爆しない)
  const $form = $("form").has("#RegisterForm-password");
  if (!$form.length) return;

  // ブラウザ標準の必須バリデーション (吹き出し) を無効化し、JS 側の表示に統一する
  $form.attr("novalidate", "novalidate");

  // 生年月日 (年/月/日) の select を取得 (存在しないページでは処理しない)
  const $year = $("#RegisterForm-birth-year");
  const $month = $("#RegisterForm-birth-month");
  const $day = $("#RegisterForm-birth-day");

  // Flow 用に customer.note へ書き込む hidden input を確保 (無ければ自動生成)
  let $note = $("#RegisterForm-note");
  if (!$note.length) {
    $note = $('<input type="hidden" id="RegisterForm-note" name="customer[note]" value="">');
    $form.append($note);
  }

  // エラー表示欄が存在しない場合でも表示できるように自動で用意する
  const ensureErrorEl = (id, $after) => {
    let $el = $("#" + id);
    if (!$el.length) {
      $el = $(`<p id="${id}" class="register-error" aria-live="polite"></p>`);
      if ($after && $after.length) {
        $after.after($el);
      } else {
        $form.prepend($el);
      }
    }
    return $el;
  };

  // 各項目の直下にエラーを出すため、基準となる DOM を取得
  const $passwordField = $("#RegisterForm-password").closest(".field");
  const $confirmField = $("#RegisterForm-password-confirm").closest(".field");
  const $birthdayBlock = $(".customer-birthday");
  const $genderBlock = $(".customer-gender");

  // エラー表示エリアを確保 (HTML に無くてもここで生成)
  const $errName = ensureErrorEl("error-name", $("#RegisterForm-FirstName").closest(".field"));
  const $errEmail     = ensureErrorEl("error-email", $("#RegisterForm-email").closest(".field"));
  const $errPassword = ensureErrorEl("error-password", $passwordField);
  const $errConfirm = ensureErrorEl("error-password-confirm", $confirmField);
  const $errBirthday = ensureErrorEl("error-birthday", $birthdayBlock);
  const $errGender = ensureErrorEl("error-gender", $genderBlock);

  // 生年月日の option を生成 (既に入っている場合は二重追加しない)
  if ($year.length && $month.length && $day.length) {
    const currentYear = new Date().getFullYear();

    // 年 (1900〜現在)
    if ($year.find("option").length <= 1) {
      for (let y = currentYear; y >= 1900; y--) {
        $year.append(`<option value="${y}">${y}</option>`);
      }
    }

    // 月 (01〜12)
    if ($month.find("option").length <= 1) {
      for (let m = 1; m <= 12; m++) {
        const v = String(m).padStart(2, "0");
        $month.append(`<option value="${v}">${m}</option>`);
      }
    }

    // 日 (01〜31)
    if ($day.find("option").length <= 1) {
      for (let d = 1; d <= 31; d++) {
        const v = String(d).padStart(2, "0");
        $day.append(`<option value="${v}">${d}</option>`);
      }
    }
  }

  // submit の二重バインドを防止 (テーマの挙動で load が複数回走っても安全にする)
  $form.off("submit.registerValidation");

  // ==================================================
  // 送信時に必須チェックを全て行い、該当箇所すべてにエラーテキストを表示する
  // ==================================================
  $form.on("submit.registerValidation", function (e) {

    // 前回表示したエラーをクリアしてから再判定する
    $errName.text("");
	$errEmail.text("");
	$errPassword.text("");
    $errConfirm.text("");
    $errBirthday.text("");
    $errGender.text("");

    // 入力値を取得
    const lastName  = $("#RegisterForm-LastName").val() || "";
	const firstName = $("#RegisterForm-FirstName").val() || "";
	const email     = $("#RegisterForm-email").val() || "";

	const password = $("#RegisterForm-password").val() || "";
    const confirmPassword = $("#RegisterForm-password-confirm").val() || "";

    const year = $year.length ? ($year.val() || "") : "";
    const month = $month.length ? ($month.val() || "") : "";
    const day = $day.length ? ($day.val() || "") : "";

    // 性別の name が揺れても拾えるように複数候補で取得
    const gender =
      $form.find('input[type="radio"][name="gender"]:checked').val() ||
      $form.find('input[type="radio"][name="customer[note][性別]"]:checked').val() ||
      $form.find('input[type="radio"][name="customer[note][gender]"]:checked').val() ||
      "";

    let hasError = false;

	// ------------------------------
	// 氏名 (姓/名) 必須チェック
	// ------------------------------
	if (!lastName.trim() || !firstName.trim()) {
	$errName.text("名前を入力してください");
	hasError = true;
	}


	// ------------------------------
	// メールアドレス 必須チェック
	// ------------------------------
	if (!email.trim()) {
	$errEmail.text("メールアドレスを入力してください");
	hasError = true;
	} else {
	// ------------------------------
	// メールアドレス 形式チェック
	// ------------------------------
	const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	if (!emailPattern.test(email.trim())) {
		$errEmail.text("メールアドレスの形式が正しくありません");
		hasError = true;
	}
	}

    // ------------------------------
    // パスワード必須チェック
    // ------------------------------
    if (!password) {
      $errPassword.text("パスワードを入力してください");
      hasError = true;
    }

    // ------------------------------
	// パスワード確認 (優先順位あり)
	// password が空のときは「不一致」は出さない
	// ------------------------------
	if (!confirmPassword) {
	// 確認が空なら常に「入力してください」
	$errConfirm.text("確認用パスワードを入力してください");
	hasError = true;
	} else if (password && password !== confirmPassword) {
	// password がある時だけ不一致判定する
	$errConfirm.text("パスワードが一致しません");
	hasError = true;
	}

    // ------------------------------
    // 生年月日必須チェック (年/月/日すべて選択)
    // ------------------------------
    if (!$year.length || !$month.length || !$day.length || !year || !month || !day) {
      $errBirthday.text("生年月日をすべて選択してください");
      hasError = true;
    }

    // ------------------------------
    // 性別必須チェック
    // ------------------------------
    if (!gender) {
      $errGender.text("性別を選択してください");
      hasError = true;
    }

    // ------------------------------
    // エラーが 1つでもあれば送信を止め、全ての該当箇所に表示する
    // ------------------------------
    if (hasError) {
      e.preventDefault();
      e.stopImmediatePropagation();

      // 最初のエラーへスクロールしてユーザーが気づけるようにする
      const $first = $(".register-error").filter(function () {
        return $(this).text().trim().length > 0;
      }).first();

      if ($first.length) {
        $first[0].scrollIntoView({ behavior: "smooth", block: "center" });
      }
      return;
    }

    // ------------------------------
    // エラーが無い場合のみ、Flow 用に customer.note へまとめて保存する
    // ------------------------------
    const birthday = `${year}-${month}-${day}`;
    $note.val([`birthday=${birthday}`, `gender=${gender}`].join("\n"));
  });
});
